export const parseBody = (body: string | undefined): unknown => {
  if (!body) return null;
  try {
    return JSON.parse(body);
  } catch {
    return body;
  }
};
